export default "__VITE_ASSET__DDYAo8gJ__"